import { render, staticRenderFns } from "./router-button.vue?vue&type=template&id=9bcc9ffe"
import script from "./router-button.vue?vue&type=script&lang=js"
export * from "./router-button.vue?vue&type=script&lang=js"
import style0 from "./router-button.vue?vue&type=style&index=0&id=9bcc9ffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports